import { AuthsApi } from './authsApi';
import { BudgetApi } from './budgetApi';
import { ChangeOrdersApi } from './changeOrdersApi';
import { CoreApi } from './coreApi';
import { InventoryApi } from './inventoryApi';
import { ProcurementApi } from './procurementApi';
import { ProductionApi } from './productionApi';
import { ProjectManagementDashboardApi } from './projectManagementDashboardApi';
import { ProjectsApi } from './projectsApi';
import { QualityControlApi } from './qualityControlApi';
import { ReleasesApi } from './releasesApi';
import { RfiApi } from './rfiApi';
import { RolesApi } from './rolesApi';
import { SubmittalsApi } from './submittalsApi';
import { UsersApi } from './usersApi';
import { MasterFilesApi } from './masterFilesApi';
import { FabricationApi } from './fabricationApi';
import { ReceivingApi } from './receivingApi';
import { StockDispatchApi } from './stockDispatchApi';
import { TrackingApi } from './trackingApi';

export const apis = [
  AuthsApi.Api,
  UsersApi.Api,
  RolesApi.Api,
  ProjectsApi.Api,
  ReleasesApi.Api,
  RfiApi.Api,
  InventoryApi.Api,
  ProcurementApi.Api,
  SubmittalsApi.Api,
  ProductionApi.Api,
  CoreApi.Api,
  ChangeOrdersApi.Api,
  BudgetApi.Api,
  ProjectManagementDashboardApi.Api,
  QualityControlApi.Api,
  MasterFilesApi.Api,
  FabricationApi.Api,
  ReceivingApi.Api,
  StockDispatchApi.Api,
  TrackingApi.Api,
];

export type ApisType = (typeof apis)[number];

export { AuthsApi } from './authsApi';
export { BudgetApi } from './budgetApi';
export { ChangeOrdersApi } from './changeOrdersApi';
export { CoreApi } from './coreApi';
export { InventoryApi } from './inventoryApi';
export { ProcurementApi } from './procurementApi';
export { ProductionApi } from './productionApi';
export { ProjectManagementDashboardApi } from './projectManagementDashboardApi';
export { ProjectsApi } from './projectsApi';
export { QualityControlApi } from './qualityControlApi';
export { ReleasesApi } from './releasesApi';
export { RfiApi } from './rfiApi';
export { RolesApi } from './rolesApi';
export { SubmittalsApi } from './submittalsApi';
export { UsersApi } from './usersApi';
export { MasterFilesApi } from './masterFilesApi';
export { FabricationApi } from './fabricationApi';
export { ReceivingApi } from './receivingApi';
export { StockDispatchApi } from './stockDispatchApi';
export { TrackingApi } from './trackingApi';
